import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SideNavigationService } from '@lmc-app/core/services/side-navigation.service';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MatDialog } from '@angular/material/dialog';
import { AgreementsCalculatorModalComponent } from '@lmc-app/summary/docusign/agreements/agreements-calculator-modal/agreements-calculator-modal.component';
import { MatButton } from '@angular/material/button';
@Component({
	selector: 'formly-calculator-button',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<button
			[type]="props['btnType'] || 'button'"
			mat-raised-button
			[color]="props['color'] || 'primary'"
			(click)="openCalculator(); props.onClick(field, $event)"
		>
			{{ props.text }}
		</button>
	`,
	imports: [MatButton],
})
export class CalculatorButtonType extends FieldType<FieldTypeConfig> {
	constructor(
		private _sidenavService: SideNavigationService,
		private _loanCalcDialog: MatDialog
	) {
		super(); // call FieldType's constructor before anything else
	}

	openCalculator() {
		// // this._sidenavService.open('oldCalculator');  // Calculator with no SAHA fee.
		const dialogRef = this._loanCalcDialog.open(
			AgreementsCalculatorModalComponent,
			{
				panelClass: 'custom-dynamic-modal',
				width: '90vw',
				height: '90vh',
				minWidth: '600px',
				minHeight: '400px',
				maxWidth: '95vw',
				maxHeight: '95vh',
				disableClose: false,
				autoFocus: true,
				data: this.field.model,
			}
		);
	}
}
